import Swiper, {Navigation, Pagination, Lazy} from "swiper";
Swiper.use([Navigation, Pagination, Lazy]);

const initParticipateSlider = () => {
  const slider = document.querySelector("[data-participate-slider]");
  if (!slider) return;

    new Swiper(slider, {
      lazy: true,
      pagination: {
        el: slider.querySelector(".swiper-pagination"),
        type: "fraction",
      },
      navigation: {
        nextEl: slider.querySelector(".slider-navigation__button--next"),
        prevEl: slider.querySelector(".slider-navigation__button--prev"),
      },
    });
};

export default initParticipateSlider;
